import { ModuleWithProviders, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { LoggingService, PinItCoreModule } from '@pit/core';

@NgModule({
    imports: [
        HttpClientModule,

        PinItCoreModule
    ]
})
export class PinItCoreDataModule {

    constructor(loggingService: LoggingService) {
        loggingService.debug('PinItCoreDataModule --> constructor()');
    }

    public static forRoot(): ModuleWithProviders<PinItCoreDataModule> {
        return {
            ngModule: PinItCoreDataModule,
            providers: []
        };
    }

}
